<template>
  <div class="tag">
    <span class="tag-name">{{label}}: </span>
    <span class="tag-value">{{value}}</span>
    <a class="remove" v-if="removable" @click="remove"></a>
  </div>
</template>

<script>

export default {
  name: 'Tag',
  props: ["label", "name", "value", "removable"],
  components: {
    
  },
  methods: {
    remove() {
      this.$emit("remove", this.name);
    }
  }
}
</script>

<style scoped>
.tag {
  display: flex;
  flex-direction: row;
  margin: 1px 10px 5px 0;
  align-items: center;
  background-color: #3394d9;
  padding: 5px 10px;
  height: 40px;
}

span {
  color: white;
  font-size: 14px;
}
.tag-name {
  margin-right:5px;
}

a.remove {
  width: 10px;
  height: 10px;
  cursor: pointer;
  background-image: url("data:image/svg+xml;charset=utf8,%3C?xml version='1.0' encoding='iso-8859-1'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='357px' height='357px' viewBox='0 0 357 357' xml:space='preserve'%3E%3Cg%3E%3Cpolygon points='357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5' fill='white'/%3E%3C/g%3E%3C/svg%3E");
  background-size: 10px 10px;
  margin-left: 5px;
}

@media all and (max-width: 800px) {
  .tag-name {
    display: none;
  }
}
</style>